/* CY Category doors, phones (owner 2026-10-22, approved proposal): a tap on a door opens it (it moves to the top, the others form one row under
   it); a tap on the open picture closes it; the button goes to the category. The change animates the doors ONLY (FLIP: each door glides from its
   old box to its new one, a uniform scale + a clip so no picture stretches). Owner 2026-10-22: "on click on mobile that effect on another sections
   also": the page-wide view transition used before froze and cross-faded every other section on screen; and the CSS now keeps the section's height.
   Desktop: nothing here, the doors open on hover in CSS. */
(() => {
  const mq = matchMedia('(max-width: 989px)'), still = matchMedia('(prefers-reduced-motion: reduce)');
  const init = grid => {
    if (grid.dataset.cycdOn) return; grid.dataset.cycdOn = '1';
    const doors = [...grid.querySelectorAll('.cycd__door')];
    const flip = change => {
      if (still.matches || !Element.prototype.animate) return change();
      const was = doors.map(x => x.getBoundingClientRect()); change();
      doors.forEach((x, i) => {
        const o = was[i], n = x.getBoundingClientRect(); if (!n.width || !n.height) return;
        const k = Math.max(o.width / n.width, o.height / n.height), ix = (n.width - o.width / k) / 2, iy = (n.height - o.height / k) / 2;
        x.animate([
          { transformOrigin: '0 0', transform: 'translate(' + (o.left - n.left - ix * k) + 'px, ' + (o.top - n.top - iy * k) + 'px) scale(' + k + ')', clipPath: 'inset(' + iy + 'px ' + ix + 'px round ' + 12 / k + 'px)' },
          { transformOrigin: '0 0', transform: 'none', clipPath: 'inset(0px 0px round 12px)' }
        ], { duration: 480, easing: 'cubic-bezier(.16, 1, .3, 1)' });
      });
    };
    const set = d => {
      const open = d && !d.classList.contains('is-open') ? d : null;
      doors.forEach(x => { x.classList.toggle('is-open', x === open); x.setAttribute('aria-expanded', x === open ? 'true' : 'false'); });
      grid.classList.toggle('has-open', !!open);
    };
    doors.forEach(d => d.addEventListener('click', e => {
      if (!mq.matches || e.target.closest('.cycd__cta')) return;
      e.preventDefault();
      flip(() => set(d));
    }));
  };
  const run = () => document.querySelectorAll('[data-cycd]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
